import { render, staticRenderFns } from "./pageDiagnosis7.vue?vue&type=template&id=21b22690&scoped=true"
import script from "./pageDiagnosis7.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis7.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis7.vue?vue&type=style&index=0&id=21b22690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b22690",
  null
  
)

export default component.exports